import paths from '@/mappings/imagePaths';

const path = (id) => `${process.env.VUE_APP_URL_CDN}/${paths[id]}`;

export {
  path,
};
